import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'
import { OrderGroup } from '#Order/models/OrderGroup'

@injectable()
export class OrderRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get index() {
    return this.router.createRouteData({ name: 'OrderIndex' })
  }

  get create() {
    return this.router.createRouteData({ name: 'OrderCreate' })
  }

  getDetail(orderId: number) {
    return this.router.createRouteData({
      name: 'OrderDetail',
      params: { id: orderId },
    })
  }

  get paymentSuccess() {
    return this.router.createRouteData({ name: 'OrderPaymentSuccess' })
  }

  get paymentFail() {
    return this.router.createRouteData({ name: 'OrderPaymentFail' })
  }

  getPaymentSuccessWithOrder(orderId: number) {
    return this.router.createRouteData({
      name: 'OrderPaymentSuccess',
      query: { orderId: String(orderId) },
    })
  }

  getPaymentFailWithOrder(orderId: number) {
    return this.router.createRouteData({
      name: 'OrderPaymentFail',
      query: { orderId: String(orderId) },
    })
  }

  get profileIndex() {
    return this.router.createRouteData({ name: 'ProfileIndex' })
  }

  profileOrders(tab: OrderGroup = OrderGroup.active) {
    return this.router.createRouteData({
      name: 'ProfileOrdersTab',
      params: { tab },
    })
  }
}
